// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50805":"186c5aef","95737":"1edebec0"}[chunkId] + ".chunk.css";
};